import React from 'react';
import useModuleGroupStore from './useModuleGroupStore';

// Context holds the Zustand hook itself (not its return value) so each
// subscriber re-renders independently when its selected slice changes.
const FlowStoreContext = React.createContext(useModuleGroupStore);

export const FlowStoreProvider = FlowStoreContext.Provider;

export function useFlowStore() {
    const hook = React.useContext(FlowStoreContext);
    return hook();
}

export default FlowStoreContext;
